import React from 'react';
import './Activities.css'; // Include your CSS file here

const skillsData1 = [
    { skill: 'JAVA' },
    { skill: 'C++' },
    { skill: 'PYTHON'},
    { skill: 'OOP'},
];

const skillsData2 = [
    { skill: 'HTML5' },
    { skill: 'CSS3' },
    { skill: 'BOOTSTRAP'},
    { skill: 'JAVASCRIPT'},
    { skill: 'REACTJS'},
];

const skillsData3 = [
    { skill: 'DBMS' },
    { skill: 'MYSQL' },
    { skill: 'CANVA'},
];


const Activities = () => {
    return (
        <section className="technical-skills" id='activities'>
            <div className='container top'>
                <div className='heading text-center'>
                    <h4>ACTIVITIES</h4>
                    <h1>Skills & Activities</h1>
                </div>


                <div className='tech_skill'>
                    <h2>Technical Skills</h2>
                    <div className="skill-list box box_shadow">
                        {skillsData1.map((skillItem, index) => (
                            <div key={index} className="skill-item">
                                <span className="skill-name">{skillItem.skill}</span>
                                {/* You can use icons, progress bars, or other elements to represent the skill level */}
                            </div>
                        ))}
                    </div>
                    <h2>Web Development Skills</h2>
                    <div className="skill-list box box_shadow">
                        {skillsData2.map((skillItem, index) => (
                            <div key={index} className="skill-item">
                                <span className="skill-name">{skillItem.skill}</span>
                                {/* You can use icons, progress bars, or other elements to represent the skill level */}
                            </div>
                        ))}
                    </div>
                    <h2>Software/Tools</h2>
                    <div className="skill-list box box_shadow">
                        {skillsData3.map((skillItem, index) => (
                            <div key={index} className="skill-item">
                                {skillItem.skill}
                                {/* You can use icons, progress bars, or other elements to represent the skill level */}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section >
    );
};

export default Activities;

